<script setup>
defineProps({
	presets: Array
});

defineEmits(['send-preset']);
</script>

<template>
  <Transition name="slide-up">
    <div
      v-if="presets.length"
      class="presets-bar"
    >
      <div class="presets-inner">
        <button
          v-for="(q, idx) in presets"
          :key="idx"
          type="button"
          class="chip"
          @click="$emit('send-preset', q)"
        >
          {{ q }}
        </button>
      </div>
    </div>
  </Transition>
</template>

<style scoped lang="scss">
  .slide-up-enter-active {
  animation: slide-up-pop 0.35s ease-out;
}

@keyframes slide-up-pop {
  0% {
    transform: translateY(100%);
    opacity: 0;
  }

  75% {
    transform: translateY(-6px);
    opacity: 1;
  }

  100% {
    transform: translateY(0);
  }
}
.presets-bar {
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(to top,
      rgba($white, 0.98) 70%,
      rgba($white, 0.85) 100%);
  backdrop-filter: saturate(120%) blur(6px);
  border-top: 1px solid $neutral-border-color;
  z-index: 1;
}

.presets-inner {
  display: flex;
  gap: 8px;
  flex-wrap: nowrap;
  overflow-x: auto;
  padding: 1rem;
  background: $white;

  &::-webkit-scrollbar {
    height: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background: $color-grey-300;
    border-radius: 4px;
  }
}

.chip {
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  border: .1rem solid $neutral-border-color;
  background: $container-bg;
  color: $neutral-main-font-color;
  padding: 1rem;
  border-radius: $borderRadius-md;
  font-size: 1.4rem;
  line-height: 1;
  cursor: pointer;
  transition: transform 0.12s ease, background 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    background: lighten($container-bg, 2%);
    transform: translateY(-1px);
    box-shadow: $thinBoxShadow;
  }

  &:active {
    transform: translateY(0);
    box-shadow: none;
  }
}
</style>
